import OverviewPill from './OverviewPill';

export default OverviewPill;
